import { useState } from "react";

import { SectionDropdown } from "../../../../components/common/SectionDropdown";
import type { IRAOnboardingProps } from "..";
import { SavedInput } from "./SavedInput";
import { SupportLink } from "./SupportLink";

export interface BasicInformationProps {
  tradeAccountDetails: IRAOnboardingProps["tradeAccountDetails"];
}

const formatAddress = (
  details: BasicInformationProps["tradeAccountDetails"],
) => {
  const parts = [details.street_address, details.city, details.state].filter(
    Boolean,
  );

  let address = parts.join(", ");

  if (details.unit) {
    address += `, #${details.unit}`;
  }

  return address || "-";
};

export const BasicInformation = ({
  tradeAccountDetails,
}: BasicInformationProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleOpen = () => setIsOpen((isOpen) => !isOpen);

  return (
    <SectionDropdown
      title="Basic Information"
      icon={<SupportLink />}
      isOpen={isOpen}
      onToggleOpen={onToggleOpen}
      className="rounded-lg border border-gray-200 bg-white p-4"
    >
      <div className="flex flex-col">
        <SavedInput
          label="Phone Number"
          value={tradeAccountDetails.phone_number}
        />
        <SavedInput
          label="Address"
          value={formatAddress(tradeAccountDetails)}
        />
        <SavedInput
          label="Tax ID Type"
          value={tradeAccountDetails.tax_id_type}
        />
        <SavedInput label="Tax ID Number" value="***-**-****" />
      </div>
    </SectionDropdown>
  );
};
